<template>
  <div style="margin-left:-4px;">
    <v-parallax style="height:100%; width:unset" :src="require('@/assets/books.jpg')">
      <div style="overflow:hidden; height:unset; width:100vw">
        <v-img contain style="max-height:200px" :src="require('@/assets/transparent-temp-logo-with-title.png')"></v-img>
        <v-img style="max-height:142px; align-items:center;" contain :src="require('../assets/name_frame_mid_ready.png')">
          <div style="max-width:100vw; max-height:142px">
            <h1 :style="`text-align:center; color:white; font-size:${fontsize}`">Privacy Policy</h1>
            <div style="text-align:center; color:white">Akashic Paths Character Sheet</div>
          </div>
        </v-img>

        <v-row justify="center" style="padding-top:80px; padding-bottom:150px">
          <v-col md="8" xs="11">
            <v-card class="background" style="min-height:500px">
              <v-img style="height:80px; margin-top:6px; align-items:center" contain :src="require('../assets/name_frame_mid_ready.png')">
                <v-card-title class="headline" style="justify-content:center; font-size:32px!important; color:white; text-align:center">
                  Your Privacy
                </v-card-title>
              </v-img>
              <v-card-text style="font-size:18px; color:white; padding: 24px 40px 40px;">
                <p style="margin-bottom:16px">
                  <strong>Last updated:</strong> August 4, 2026
                </p>
                <p style="margin-bottom:16px">
                  This Privacy Policy applies to the Akashic Paths Character Sheet website and related Roll20 plugin (the "Service").
                  The Service is a tabletop character sheet tool for Pathfinder / Akashic Paths gameplay.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Information We Do Not Collect</h3>
                <p style="margin-bottom:16px">
                  We do not collect, store, sell, or share private personal information such as your real name, home address,
                  phone number, payment details, or browsing history for advertising or marketing purposes.
                  This Service is a character sheet website — not a data-harvesting platform.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Character Sheet Data</h3>
                <p style="margin-bottom:16px">
                  The only information associated with use of the Service is game-related character sheet data
                  (for example character names, stats, inventory, and similar tabletop RPG content) that you choose to enter
                  so the sheet can function. This data is used solely to provide the character sheet and plugin features.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Third-Party Services</h3>
                <p style="margin-bottom:16px">
                  If you use the Service together with Roll20 or similar platforms, those services have their own privacy policies.
                  We do not control how those third parties handle your information.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Cookies &amp; Analytics</h3>
                <p style="margin-bottom:16px">
                  We do not use advertising cookies or third-party marketing trackers on this Privacy Policy page or as part of
                  the character sheet Service for the purpose of selling personal data.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Children's Privacy</h3>
                <p style="margin-bottom:16px">
                  The Service is not directed at children under 13, and we do not knowingly collect private personal information from children.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Changes to This Policy</h3>
                <p style="margin-bottom:16px">
                  We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.
                </p>

                <h3 style="color:white; margin-top:24px; margin-bottom:8px">Contact</h3>
                <p style="margin-bottom:8px">
                  If you have questions about this Privacy Policy, contact us at
                  <b style="font-weight:800">akashicpaths@gmail.com</b>
                  or through the
                  <a href="https://discord.gg/ZTrp4aS7C3" style="color:#9fd3ff">Official Discord</a>.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-parallax>
  </div>
</template>

<script>
import {
  VRow,
  VCol,
  VCard,
  VCardTitle,
  VCardText,
  VParallax,
  VImg,
} from "vuetify/lib";

export default {
  components: {
    VRow,
    VCol,
    VCard,
    VCardTitle,
    VCardText,
    VParallax,
    VImg,
  },
  computed: {
    fontsize() {
      if (window.innerWidth < 541) {
        return "1.3em";
      } else {
        return "2em";
      }
    },
  },
};
</script>

<style>
.background {
  background: url('../assets/big_bar.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: center;
}
.v-parallax__image-container {
  contain: unset !important;
  width: 100vw;
  height: 40vh;
}
.v-parallax__content {
  padding-left: 4px;
}
</style>
